import { Directive, Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validator } from '@angular/forms';

@Injectable()
export class FormFieldCharacterValidator implements Validator {
    validator: Function;

    constructor(){
        this.validator =  FormFieldCharacterValidator.FormFieldCharacterValidatorFactory();
    }

    validate(control: AbstractControl): ValidationErrors {
        return this.validator(control);
    }

    static FormFieldCharacterValidatorFactory(regExp?: string) {
        let testExp;
        if(regExp){
            testExp = regExp
        }else{
            testExp= "^[^=-@%+].*";
        }
        return (c: FormControl) => {
            const v = c.value;
            if(v){
                let strongRegex = new RegExp(testExp);
                let result = strongRegex.test(v);
                //console.log(`Field validation: testing ${v} against ${testExp} gave ${result}`)
                return result ? null : { characterError: true };
            }else{
                
                return null;
            }
        }
    }
}